// The finance tabs' search box (DD-042, the `q` URL param): one rule for Money, Clients, Team and Expenses. Pure
// so it can be tested.

/** Whether a row matches the search: no search matches everything; else any of its texts holds it, in any case. */
export function matchesSearch(q: string, texts: (string | null | undefined)[]): boolean {
  const text = q.trim().toLowerCase();
  return !text || texts.some((t) => !!t && t.toLowerCase().includes(text));
}
